import React from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

import { CategoriesList } from '../../store'

import { Tour, TourCategory } from 'generated/mos/org/getty/audio'
import { SetReleaseStatusRequest } from 'generated/mos/releasecontrolsmanagement'
import { ValidationFailure } from 'generated/mos/org/getty/validation'

import { CategoryItem } from './category-item'

import { dndReorder } from 'helpers/drag-and-drop'

type Props = {
  readonly categories: CategoriesList;
  readonly projectId: string;
  readonly historyPush: (to: string) => void;
  readonly orderedCategories: ReadonlyArray<TourCategory.Entity>;
  readonly setOrderedCategories: React.Dispatch<React.SetStateAction<ReadonlyArray<TourCategory.Entity> | undefined>>;
  readonly deleteHandler: (category: TourCategory.Entity) => void;
  readonly editHandler: (editHandler: TourCategory.Entity) => void;
  readonly updateToursHandler: (editHandler: TourCategory.Entity) => void;
  readonly releaseControlUpdate: (bundles: ReadonlyArray<SetReleaseStatusRequest.BundleStatus.Entity>, ref: TourCategory.Ref) => void;
  readonly validationFailures: ReadonlyArray<ValidationFailure.Entity> | undefined;
}

export const ReorderableCategories = ({ categories, orderedCategories, setOrderedCategories, deleteHandler, editHandler, updateToursHandler, releaseControlUpdate, validationFailures }: Props) => {
  const setOrderedCategoryTours = (categoryRef: TourCategory.Ref) => (tourRefs: ReadonlyArray<Tour.Ref>) => {
    const updatedCategories = orderedCategories.map(category => {
      if(category.ref === categoryRef) {
        return {
          ...category,
          tourRefs,
        }
      }
      return category
    })
    setOrderedCategories(updatedCategories)
  }

  const failures = validationFailures ? validationFailures.filter(({ ref }) => ref && ref.typename === TourCategory.refName) : undefined

  return (
    <DragDropContext onDragEnd={dropResult => setOrderedCategories(dndReorder(dropResult, orderedCategories))}>
      <Droppable droppableId="categories-list">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {orderedCategories.map((category, index) => {
              const id = category.ref ? category.ref.id : ''
              return (
                <Draggable draggableId={id} key={id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CategoryItem
                        hasWarning={failures && !!failures.find(({ ref }: ValidationFailure.Entity) => ref && ref.id === id)}
                        isDragging={snapshot.isDragging}
                        draggableIndex={index}
                        categories={categories}
                        category={category}
                        deleteHandler={deleteHandler}
                        editHandler={editHandler}
                        updateToursHandler={updateToursHandler}
                        setOrderedCategoryTours={setOrderedCategoryTours(TourCategory.mustRef(category.ref))}
                        releaseControlUpdate={releaseControlUpdate}
                      />
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

